import type { ToolDefinition } from '../types'

export const tools: ToolDefinition[] = [
  {
    id: 'compress',
    title: '이미지 압축',
    shortTitle: '압축',
    description: '화질은 두고 용량만 줄인다.',
    category: '최적화',
    workbenchGroup: '줄이기',
    action: '용량 줄이기',
    accent: 'yellow',
    multiple: true,
  },
  {
    id: 'resize',
    title: '크기 바꾸기',
    shortTitle: '리사이즈',
    description: '가로세로 숫자를 정해 한 번에 맞춘다.',
    category: '편집',
    workbenchGroup: '줄이기',
    action: '크기 맞추기',
    accent: 'blue',
    multiple: true,
  },
  {
    id: 'crop',
    title: '이미지 자르기',
    shortTitle: '자르기',
    description: '필요한 부분만 남기고 나머지는 자른다.',
    category: '편집',
    workbenchGroup: '줄이기',
    action: '딱 맞게 자르기',
    accent: 'mint',
    multiple: true,
  },
  {
    id: 'convert-jpg',
    title: 'JPG로 변환',
    shortTitle: 'JPG 변환',
    description: 'PNG와 WEBP를 어디서나 열리는 JPG로 바꾼다.',
    category: '변환',
    workbenchGroup: '바꾸기',
    action: 'JPG로 바꾸기',
    accent: 'orange',
    multiple: true,
  },
  {
    id: 'convert-png',
    title: 'JPG에서 변환',
    shortTitle: 'PNG·WEBP',
    description: 'JPG를 PNG 또는 WEBP로 다시 뽑는다.',
    category: '변환',
    workbenchGroup: '바꾸기',
    action: '포맷 바꾸기',
    accent: 'violet',
    multiple: true,
  },
  {
    id: 'html-to-image',
    title: 'HTML을 이미지로',
    shortTitle: 'HTML 캡처',
    description: '작성한 HTML과 CSS를 한 장의 이미지로 뽑는다.',
    category: '변환',
    workbenchGroup: '바꾸기',
    action: '코드 캡처하기',
    badge: '새 공구',
    accent: 'blue',
    multiple: false,
  },
  {
    id: 'rotate',
    title: '회전 & 뒤집기',
    shortTitle: '회전',
    description: '돌리고 뒤집는다. 여러 장도 같은 방향으로.',
    category: '편집',
    workbenchGroup: '바꾸기',
    action: '방향 돌리기',
    accent: 'pink',
    multiple: true,
  },
  {
    id: 'watermark',
    title: '워터마크 넣기',
    shortTitle: '워터마크',
    description: '문구를 원하는 자리에 단단히 박는다.',
    category: '보안',
    workbenchGroup: '손보기',
    action: '표시 박기',
    accent: 'blue',
    multiple: true,
  },
  {
    id: 'editor',
    title: '포토 에디터',
    shortTitle: '에디터',
    description: '밝기, 대비, 채도만 필요한 만큼 손본다.',
    category: '편집',
    workbenchGroup: '손보기',
    action: '색감 손보기',
    badge: '자주 씀',
    accent: 'yellow',
    multiple: true,
  },
  {
    id: 'upscale',
    title: '선명하게 확대',
    shortTitle: '업스케일',
    description: '작은 이미지를 2배 또는 4배 키운다.',
    category: '최적화',
    workbenchGroup: '줄이기',
    action: '크게 키우기',
    badge: '보간',
    accent: 'violet',
    multiple: true,
  },
  {
    id: 'remove-bg',
    title: '배경 지우기',
    shortTitle: '배경 제거',
    description: '네 모서리 색을 읽어 단색 배경을 날린다.',
    category: '보안',
    workbenchGroup: '지우기',
    action: '배경 날리기',
    badge: '시험 중',
    accent: 'mint',
    multiple: true,
  },
  {
    id: 'meme',
    title: '밈 만들기',
    shortTitle: '밈',
    description: '위아래 문구를 넣고 바로 공유용 밈으로.',
    category: '만들기',
    workbenchGroup: '손보기',
    action: '밈 만들기',
    accent: 'orange',
    multiple: true,
  },
  {
    id: 'blur',
    title: '프라이버시 블러',
    shortTitle: '흐리기',
    description: '민감한 이미지 전체를 읽기 어렵게 흐린다.',
    category: '보안',
    workbenchGroup: '지우기',
    action: '전부 흐리기',
    accent: 'pink',
    multiple: true,
  },
]
